import React, { Component } from 'react';
import { connect } from 'react-redux';
import { siteSettingsState, identityState,detailedSearchState, repositoryState, combineStates, 
  filterDispatcher, detailedSearchDispatcher, combineDispatchers } from '../store';
import { SvgImage, Checkbox } from '.';
import { stockIcon} from '../../style/images';
import { translate, localStore } from '../services';
import { Toggle } from './ToggleSwitch';

export class StockFilterComponent extends Component{
  constructor(){
    super();
    this.state = {
      stockFilterSelected : false,
    }
  }
  
  onStockFilterChanged = () => {
    const { currentSelector, filterSelectors, user, hasStockFilter, isSearchPage, pageResult } = this.props;
    this.setState({ stockFilterSelected: hasStockFilter ? !hasStockFilter : !this.state.stockFilterSelected },
      () => isSearchPage ? this.props.searchProducts( pageResult.request.query, pageResult, pageResult.pageSize, this.state.stockFilterSelected )
        .then( localStore.set( 'isStockFilterSelected', this.state.stockFilterSelected  ) ) 
      : this.props.updateSelectedValue( filterSelectors, currentSelector.selector, user, null, 0, this.state.stockFilterSelected )
        .then( localStore.set( 'isStockFilterSelected', this.state.stockFilterSelected  ) )
    );
  }
  
  render(){
    const { siteSettings, active } = this.props;
    const hasStockFilter = this.props.hasStockFilter || localStore.get( 'isStockFilterSelected' );
    const titleForStockFilterCheckBox =<span><SvgImage source={ stockIcon }/>&nbsp;{translate("Stock Filter")}</span>;
    return <div className='stock-toggle'>
      {/* <Checkbox title={ titleForStockFilterCheckBox  } 
      showInlineNoWrapText={siteSettings.showStockFilter} 
      checked={ siteSettings.showStockFilter && hasStockFilter } 
      onChange={ this.onStockFilterChanged }/> */}
      <span>{translate("Available:")}</span>
      <Toggle
          label={titleForStockFilterCheckBox}
          showInlineNoWrapText={siteSettings.showStockFilter}
          toggled={siteSettings.showStockFilter && hasStockFilter}
          onClick={this.onStockFilterChanged}
          ></Toggle>
    </div>
  }
}

export const StockFilter = connect( combineStates( siteSettingsState, identityState, repositoryState( 'selector' ), detailedSearchState ),
combineDispatchers(detailedSearchDispatcher,filterDispatcher))( StockFilterComponent );